export const padCalendar = ar => {
	if (Array.isArray(ar)) {
		if (ar.length > 3) {
			ar = ar.slice(0, 3);
		}

		let month = ar[1] + "";
		ar[1] = month.padStart(2, "0");

		let day = ar[2] + "";
		ar[2] = day.padStart(2, "0");

		return ar.join("-");
	}

	return ar;
};

export const numberWithCommas = x => {
	let parts = x.toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	return parts.join(".");
};

export const dollarFormat = x => {
	return "$" + Math.round(x, 2);
};

export const dollarFormatWithCommas = x => {
	let parts = Math.round(x, 2).toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	return "$" + parts.join(".");
};

export const roundTo2Decimals = x => {
	return Math.round(x * 100) / 100;
};

export const numTo2DecimalsPercent = x => {
	if(x != null)
		return "" + Math.round(x * 100, 2) + "%";
	else
		return "--";
};

export const toDate = dateArray => {
	return new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
};

export const allowAlphaNumeric = e => {
	var code = "charCode" in e ? e.charCode : e.keyCode;
	if (
		!(e.ctrlKey && (code === 88 || code === 67 || code === 86)) &&
		!(code > 47 && code < 58) && // numeric (0-9)
		!(code > 64 && code < 91) && // upper alpha (A-Z)
		!(code > 96 && code < 123) // lower alpha (a-z)
	) {
		e.preventDefault();
	}
};

export const onlyNumeric = e => {
	var code = "charCode" in e ? e.charCode : e.keyCode;
	if (
		!(code > 47 && code < 58) // numeric (0-9)
	) {
		e.preventDefault();
	}
};

export const getProperDate = data => {
	if (data) {
		var date = new Date(data);
		var year = date.getFullYear();
		var month = (1 + date.getMonth()).toString().padStart(2, "0");
		var day = date
			.getDate()
			.toString()
			.padStart(2, "0");
		return month + "/" + day + "/" + year;
	} else {
		return "";
	}
};

export const getTodaysDate = () => {
	
	let date = new Date();
	var year = date.getFullYear();
	var month = (1 + date.getMonth()).toString().padStart(2, "0");
	var day = date
		.getDate()
		.toString()
		.padStart(2, "0");
	return month + "/" + day + "/" + year;
	
};

export const ConvertTimeZoneValue = date => {
	if (date) {
		return new Date(
			new Date(date).getTime() - new Date(date).getTimezoneOffset() * 60 * 1000
		);
	} else {
		return "";
	}
};

export const formatDateAdded = ([yyyy,mm,dd]) => {
	const format = (num) => num.toString().padStart(2, '0');
	return (yyyy && mm && dd) ? `${format(yyyy)}-${format(mm)}-${format(dd)}` : "--";
}

export const isAdmin = () => localStorage.getItem("isAdminToken") === "false" ? false : true;

export const getEntryClass = (dando) => `commission-selector-${dando.dandoId===null ? 'entrynull' : 'entry'}`;

export const isDandoEnabled = ({ DandOEnabled, subscription }) => !isAdmin() && DandOEnabled && subscription;

export const getFunctionList = () => ([
  "Board Director",
  "Corporate Counsel",
  "Corporate Executive",
  "Corporate Officer",
  "Family Office",
  "General Counsel",
  "Hedge Fund",
  "Insurance Intermediary",
  "Institutional Investor",
  "Insurance Underwriter",
  "Investment Professional",
  "Investor Relations",
  "Litigator",
  "Reinsurer",
  "Risk Professional",
  "Other",
]) 

export const getUSstates = () => ([
	{
		"name": "Alabama",
		"value": "AL"
	},
	{
		"name": "Alaska",
		"value": "AK"
	},
	{
		"name": "American Samoa",
		"value": "AS"
	},
	{
		"name": "Arizona",
		"value": "AZ"
	},
	{
		"name": "Arkansas",
		"value": "AR"
	},
	{
		"name": "California",
		"value": "CA"
	},
	{
		"name": "Colorado",
		"value": "CO"
	},
	{
		"name": "Connecticut",
		"value": "CT"
	},
	{
		"name": "Delaware",
		"value": "DE"
	},
	{
		"name": "District Of Columbia",
		"value": "DC"
	},
	{
		"name": "Federated States Of Micronesia",
		"value": "FM"
	},
	{
		"name": "Florida",
		"value": "FL"
	},
	{
		"name": "Georgia",
		"value": "GA"
	},
	{
		"name": "Guam",
		"value": "GU"
	},
	{
		"name": "Hawaii",
		"value": "HI"
	},
	{
		"name": "Idaho",
		"value": "ID"
	},
	{
		"name": "Illinois",
		"value": "IL"
	},
	{
		"name": "Indiana",
		"value": "IN"
	},
	{
		"name": "Iowa",
		"value": "IA"
	},
	{
		"name": "Kansas",
		"value": "KS"
	},
	{
		"name": "Kentucky",
		"value": "KY"
	},
	{
		"name": "Louisiana",
		"value": "LA"
	},
	{
		"name": "Maine",
		"value": "ME"
	},
	{
		"name": "Marshall Islands",
		"value": "MH"
	},
	{
		"name": "Maryland",
		"value": "MD"
	},
	{
		"name": "Massachusetts",
		"value": "MA"
	},
	{
		"name": "Michigan",
		"value": "MI"
	},
	{
		"name": "Minnesota",
		"value": "MN"
	},
	{
		"name": "Mississippi",
		"value": "MS"
	},
	{
		"name": "Missouri",
		"value": "MO"
	},
	{
		"name": "Montana",
		"value": "MT"
	},
	{
		"name": "Nebraska",
		"value": "NE"
	},
	{
		"name": "Nevada",
		"value": "NV"
	},
	{
		"name": "New Hampshire",
		"value": "NH"
	},
	{
		"name": "New Jersey",
		"value": "NJ"
	},
	{
		"name": "New Mexico",
		"value": "NM"
	},
	{
		"name": "New York",
		"value": "NY"
	},
	{
		"name": "North Carolina",
		"value": "NC"
	},
	{
		"name": "North Dakota",
		"value": "ND"
	},
	{
		"name": "Northern Mariana Islands",
		"value": "MP"
	},
	{
		"name": "Ohio",
		"value": "OH"
	},
	{
		"name": "Oklahoma",
		"value": "OK"
	},
	{
		"name": "Oregon",
		"value": "OR"
	},
	{
		"name": "Palau",
		"value": "PW"
	},
	{
		"name": "Pennsylvania",
		"value": "PA"
	},
	{
		"name": "Puerto Rico",
		"value": "PR"
	},
	{
		"name": "Rhode Island",
		"value": "RI"
	},
	{
		"name": "South Carolina",
		"value": "SC"
	},
	{
		"name": "South Dakota",
		"value": "SD"
	},
	{
		"name": "Tennessee",
		"value": "TN"
	},
	{
		"name": "Texas",
		"value": "TX"
	},
	{
		"name": "Utah",
		"value": "UT"
	},
	{
		"name": "Vermont",
		"value": "VT"
	},
	{
		"name": "Virgin Islands",
		"value": "VI"
	},
	{
		"name": "Virginia",
		"value": "VA"
	},
	{
		"name": "Washington",
		"value": "WA"
	},
	{
		"name": "West Virginia",
		"value": "WV"
	},
	{
		"name": "Wisconsin",
		"value": "WI"
	},
	{
		"name": "Wyoming",
		"value": "WY"
	}
]);

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
const zipRegex = /^\d{5}(?:[-\s]\d{4})?$/;
// var regularExpression = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
// let regex =  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&^])[A-Za-z\d@.#$!%*?&]{8,15}$/;
export const validate = {
	email: (email) => String(email).toLowerCase().match(emailRegex),
	phone: (phone) => String(phone).match(phoneRegex),
	zip: (zip) => String(zip).match(zipRegex)
}

export const convertUnixToDateTime = (unixTimestamp) => {
	const date = new Date(unixTimestamp * 1000);
  
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	const year = date.getFullYear();
  
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	const seconds = String(date.getSeconds()).padStart(2, "0");
  
	return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
  }

export const formatCurrencyUSD = (amount) => {
	return new Intl.NumberFormat("en-US", {
	  style: "currency",
	  currency: "USD",
	  minimumFractionDigits: 0,
	  maximumFractionDigits: 0,
	}).format(amount);
};
  


// WEBPACK FOOTER //
// ./src/util.js